import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Uncategorized Service Stores
 * These stores don't have corresponding api-types directories yet
 */
export const uncategorizedStores: ServiceStoreConfig[] = [
  {
    name: "plants",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
      },
    },
  },
  {
    name: "suppliers",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.suppliersStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalSuppliers = entities.length;
          const activeSuppliers = entities.filter(
            (supplier: Record<string, unknown>) =>
              supplier.status === "active" || supplier.isActive !== false
          ).length;
          const preferredSuppliers = entities.filter(
            (supplier: Record<string, unknown>) =>
              supplier.isPreferred || supplier.tier === "preferred"
          ).length;
          const totalSpend = entities.reduce(
            (sum: number, supplier: Record<string, unknown>) => {
              return sum + ((supplier.totalSpend as number) || 0);
            },
            0
          );

          return [
            {
              title: "Total Suppliers",
              value: () => totalSuppliers.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeSuppliers.toString(),
              valueColor: "success.main",
            },
            {
              title: "Preferred",
              value: () => preferredSuppliers.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Total Spend",
              value: () => `$${((totalSpend as number) / 1000).toFixed(0)}K`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "customers",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.customersStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalCustomers = entities.length;
          const activeCustomers = entities.filter(
            (customer: Record<string, unknown>) =>
              customer.status === "active" || !customer.inactive
          ).length;
          const vipCustomers = entities.filter(
            (customer: Record<string, unknown>) =>
              customer.isVip ||
              customer.tier === "gold" ||
              customer.tier === "platinum"
          ).length;
          const totalRevenue = entities.reduce(
            (sum: number, customer: Record<string, unknown>) => {
              return (
                sum +
                ((customer.totalRevenue as number) ||
                  (customer.lifetime_value as number) ||
                  0)
              );
            },
            0
          );

          return [
            {
              title: "Total Customers",
              value: () => totalCustomers.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeCustomers.toString(),
              valueColor: "success.main",
            },
            {
              title: "VIP",
              value: () => vipCustomers.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Total Revenue",
              value: () => `$${((totalRevenue as number) / 1000).toFixed(0)}K`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "search-query-builder",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "accounting",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "conversion-drafts",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  // Note: The following were moved to their respective category files:
  // - hardware-orders -> hardware.stores.ts
  // - list-tracker -> organization-data.stores.ts
  // - scheduling-day, dates/holidays, schedule-generator -> scheduling.stores.ts
  // - api-services, azure-blob-storage -> system.stores.ts
];